<template>
	<div class="form">
		<!-- <van-uploader :after-read="afterRead">
		  <div class="avator">
		  	<img :src="userInfo.avatar" alt="" />
		  	<div>更换头像</div>
		  </div>
		</van-uploader> -->
		<div class="avator" @click="getPic">
			<img :src="userInfo.avatar" alt="" />
			<div>更换头像</div>
		</div>
		<div class="form-item">
			<div class="label">姓名：</div>
			<van-field center clearable v-model="userName" placeholder="请输入姓名" />
		</div>
		<div class="form-item">
			<div class="label">城市/地区：</div>
			<van-field
			  v-model="fieldValue"
			  is-link
			  readonly
			  placeholder="请选择所在地区"
			  @click="show = true"
			/>
			<van-popup v-model="show" round position="bottom">
			  <van-cascader
			    v-model="cascaderValue"
			    title="请选择所在地区"
			    :options="options"
			    @close="show = false"
			    @change="onChange"
			    @finish="onFinish"
				:field-names="fieldNames"
			  />
			</van-popup>
		</div>
		<div class="form-item">
			<div class="label">学校：</div>
			<van-field
			  v-model="schoolValue.text"
			  is-link
			  readonly
			  placeholder="请选择学校"
			  @click="onSchoolClick"
			/>
			<van-popup v-model="showSchoolPopup" round position="bottom">
			  <van-picker
			    :columns="schoolOptions"
				show-toolbar
			    title="请选择学校"
			    @cancel="showSchoolPopup = false"
			    @confirm="onSchoolConfirm"
			  />
			</van-popup>
		</div>
		<div class="form-item">
			<div class="label">年级/班级：</div>
			<van-field
			  v-model="gradeClassValue"
			  is-link
			  readonly
			  placeholder="请选择年级和班级"
			  @click="onGradeClassClick"
			/>
			<van-popup v-model="showGradeClassPopup" round position="bottom">
			  <van-cascader
			    v-model="gradeClassCascaderValue"
			    title="请选择年级和班级"
			    :options="gradeClassOptions"
			    @close="showGradeClassPopup = false"
			    @finish="onGradeClassFinish"
				:field-names="fieldNames"
			  />
			</van-popup>
		</div>
		<van-button class="submit" @click="submit" size="large">提交</van-button>
		
		<el-dialog title="头像列表" width="80%" :visible.sync="showPic">
			<div class="pic-cont">
				<img :class="actIndex == index?'act-pic':''" @click="actIndex = index" v-for="(item,index) in picList" :src="item.filePath" alt="" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" class="enter" @click="picConfirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'index',
	props: ["select"],
	data() {
		return {
			userInfo:{},
			userName:"",
			schoolValue: {},
			gradeClassValue: '',
			parentid: 1,
			formdata: {
				name: "",
			},
			show: false,
			showSchoolPopup: false,
			showGradeClassPopup: false,
			fieldValue: '',
			fieldNames: {
				text: 'name',
				value: 'id',
				children: 'children',
			},
			cascaderValue: '',
			gradeClassCascaderValue: '',
			options: [],
			schoolOptions: [],
			gradeClassOptions: [],
			selectedCityId: null,
			showPic:false,
			picList:[],
			actIndex:0
		}
	},

	created() {
		this.getUserInfo();
		this.getCity(this.parentid, true);
	},

	methods: {
		async getPic() {
			this.showPic = true;
			const res = await this.$api.getPic();
			if (res.data.success) {
				this.picList = res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async picConfirm() {
			this.showPic = false;
			const res = await this.$api.uploadAvatar({
				path:this.picList[this.actIndex].path
			});
			if (res.data.success) {
				this.userInfo.avatar = res.data.data.avatar;
				// 根据需求保存返回的图片URL或其他信息
			} else {
				this.$message.error(res.data.message || "上传失败");
			}
		},
		
		async getCity(parentid, updateOptions = false) {
			let jsondata = { parentid };
			const res = await this.$api.getCityList(jsondata);
			if (res.data.code === 0) {
				if (updateOptions) {
					this.options = res.data.data;
				} else {
					return res.data.data;
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},

		async onChange({ value, selectedOptions }) {
			const lastSelected = selectedOptions[selectedOptions.length - 1];
			if (lastSelected && !lastSelected.children) {
				const children = await this.getCity(lastSelected.id);
				if (children && children.length > 0) {
					lastSelected.children = children;
					this.options = [...this.options];
				} else {
					this.selectedCityId = lastSelected.id;
					this.show = false;
				}
			}
		},

		onFinish({ selectedOptions }) {
			this.fieldValue = selectedOptions.map(option => option.name).join('/');
		},

		async fetchSchools(cityId, schoolType) {
			const res = await this.$api.getSchoolList({
				city_id: cityId,
				school_type: schoolType
			});
			if (res.data.code === 0) {
				this.schoolOptions = res.data.data.map(school => ({ text: school.name, id: school.id }));
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},

		async onSchoolClick() {
			if (this.selectedCityId) {
				await this.fetchSchools(this.selectedCityId, localStorage.getItem("schoolType"));
				this.showSchoolPopup = true;
			} else {
				this.$message.warning("请先选择城市/地区");
			}
		},

		onSchoolConfirm(selectedSchool) {
			this.schoolValue = selectedSchool;
			this.showSchoolPopup = false;
		},

		onGradeClassClick() {
			this.gradeClassOptions = this.generateGradeClassOptions();
			console.dir(this.gradeClassOptions)
			this.showGradeClassPopup = true;
		},

		generateGradeClassOptions() {
			const schoolType = localStorage.getItem("schoolType");
			const grades = schoolType === "C" ? ["初一", "初二", "初三"] : ["高一", "高二", "高三"];
			return grades.map((grade, index) => ({
				name: grade, // 使用 name 字段，确保与 fieldNames.text 对应
				id: index, // 使用 id 字段，确保与 fieldNames.value 对应
				children: Array.from({ length: 10 }, (_, i) => ({ 
					name: `${i + 1}班`, // 使用 name 字段
					id: `${index}-${i + 1}` // 唯一 ID
				})),
			}));
		},


		onGradeClassFinish({ selectedOptions }) {
			this.gradeClassValue = selectedOptions.map(option => option.name).join('/');
			this.showGradeClassPopup = false;
		},
		
		async afterRead(file) {
			const formData = new FormData();
			formData.append('file', file.file); // 文件字段名为 "file"
				
			try {
				const res = await this.$api.uploadAvatar(formData);
				if (res.data.success) {
					this.userInfo.avatar = res.data.data.avatar;
					this.$message.success("上传成功");
					// 根据需求保存返回的图片URL或其他信息
				} else {
					this.$message.error(res.data.message || "上传失败");
				}
			} catch (error) {
				this.$message.error("上传失败，请重试");
			}
		},
		
		async getUserInfo(){//获取用户信息
		if(JSON.parse(localStorage.getItem("userInfo")).accountCode == "13312345678"){
			this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
			return
		}
			const res = await this.$api.userInfo({});
			if (res.data.success) {
				this.userInfo = res.data.data
				this.userName = res.data.data.userName
				this.schoolValue.text = res.data.data.school
				this.schoolValue.Id = res.data.data.schoolId
				this.selectedCityId = res.data.data.cityId
				this.fieldValue = res.data.data.city
				this.gradeClassValue = res.data.data.gradeClass
				localStorage.setItem("userInfo",JSON.stringify(res.data.data))
			}else{
			  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
		
		async submit(){//保存
			let jsondata = {
				userName: this.userName,
				school: this.schoolValue.text,
				schoolId: this.schoolValue.id,
				gradeClass: this.gradeClassValue,
				gradeType:this.gradeClassValue.indexOf('初')!=-1?1:2,
				cityId:this.selectedCityId,
				city:this.fieldValue,
			};
			const res = await this.$api.updateUser(jsondata);
			console.dir(res.data.success)
			if (res.data.success) {
				this.$message.success("更新成功")
				if(this.select){
					this.$router.push({  //核心语句
					  path:'/home',   //跳转的路径
					  query:{}
					})
				}else{
					location.reload();
				}
			}else{
			  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
	}
}
</script>






<style lang="scss" scoped>
	.form{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		.avator{
			width: 8.7rem;
			height: 8.7rem;
			border-radius: 100%;
			margin-bottom: 4rem;
			position: relative;
			overflow: hidden;
			border: 1px solid #ccc;
			img{
				width: 8.7rem;
				height: 8.7rem;
				border-radius: 100%;
				margin-bottom: 4rem;
			}
			div{
				position: absolute;
				width: 100%;
				padding: .5rem 0;
				font-size: 1rem;
				bottom: 0;
				left: 0;
				color: #fff;
				background-color: rgba(0, 0, 0, .5);
				text-align: center;
			}
		}
		.form-item{
			display: flex;
			align-items: center;
			margin-bottom: 1.5rem;
			.label{
				width: 8rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: #282D30;
				line-height: 1.41rem;
				text-align: right;
				margin-right: 1.5rem;
			}
			.van-cell{
				width: 28.6rem;
				height: 3.1rem;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				border: 0.05rem solid #E0E0E0;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				line-height: 2.1rem;
			}
			.van-button{
				width: 6.15rem;
				height: 1.85rem;
				background: rgb(100, 45, 113);
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1rem;
				color: #FFFFFF;
				line-height: 1.85rem;
				text-align: center;
			}
			::v-deep .van-field__button{
				display: flex;
			}
		}
		.submit{
			width: 8.4rem;
			height: 2.9rem;
			background: rgb(100, 45, 113);
			border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.4rem;
			color: #FFFFFF;
			line-height: 2.9rem;
			text-align: center;
			margin-top: 1rem;
		}
	}
	.pic-cont{
		display: flex;
		flex-wrap: wrap;
		height: 60vh;
		overflow: auto;
		img{
			margin: 10px;
			width: 200px;
			height: 200px;
			border-radius: 100%;
			border: 5px solid rgba(0, 0, 0, 0);
		}
	}
	.act-pic{
		border: 8px solid #642d71!important;
	}
</style>